import { Button, ButtonGroup, Dropdown, PageHeaderControl } from '@salesforce/design-system-react';

export const actions = (props) => {
  const { onAddAction, onDropDownSelect, value, options, btnLabel } = props;
  return (
    <PageHeaderControl>
      <ButtonGroup id="button-group-page-header-actions">
        {
          btnLabel && (
            <Button onClick={(el) => onAddAction(el)} label={btnLabel} />
          )
        }
        {props.showDropdown !== false ? (
          <Dropdown
            align="right"
            assistiveText={{ icon: 'Checkmark' }}
            checkmark
            iconCategory="utility"
            iconName="down"
            iconVariant="border-filled"
            id="page-header-dropdown-object-home-nav-right"
            value={value}
            onSelect={(selected) => onDropDownSelect(selected.value)}
            options={options}
          />
        ) : (
          <></>
        )}
      </ButtonGroup>
    </PageHeaderControl>
  );
};
